import * as React from 'react';
import { useDeviceType } from '@cian/ui-kit';

import { ValuationFiltersMobile } from './views/mobile';
import { ValuationFiltersDesktop } from './views/desktop';
import { IValuationFiltersProps } from './types';
import { TRefWrapper } from '../../containers/Scrolling';

interface IRefWrapperProps {
  refWrapper: TRefWrapper;
}

export const ValuationFilters: React.FC<IValuationFiltersProps & IRefWrapperProps> = ({ refWrapper, ...props }) => {
  const ValuationFiltersView = useDeviceType() === 'desktop' ? ValuationFiltersDesktop : ValuationFiltersMobile;

  return <ValuationFiltersView refWrapper={refWrapper} {...props} />;
};
